<template>
  <div class="container">
    <section id="editContent" :data-responsive="responsive" class="columnContainer settingPage">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.nav_setting}}</h1>
        <div class="flexBox">
          <div class="flexInner">
            <Site :site="setting.site" :lang="setting.lang" :locale="locale" @onSave="save" />
            <Lang :lang="setting.lang" :locale="locale" />
            <Currency :currency="setting.currency" :locale="locale" />
            <Date :date="setting.date" :locale="locale" />
            <Font :font="setting.font" :locale="locale" @onSave="save" />
            <Order :order="setting.order" :responsive="responsive" :lang="setting.lang" :locale="locale" />
            <Mypage :mypage="setting.mypage" :locale="locale" />
            <GuestType v-if="setting.guestType && setting.guestType.length" :guestType="setting.guestType" :lang="setting.lang" :locale="locale" />
            <!-- <Inroom :inroom="setting.inroom" :locale="locale" /> -->
          </div>
          <div class="flexInner">
            <Skin :skin="setting.skin" :responsive="responsive" :locale="locale" />
            <Header :site="setting.site" :colors="setting.colors" :pointcolors="setting.pointcolors" :imgs="setting.imgs" :responsive="responsive" :locale="locale" />
            <Footer :colors="setting.colors" :footer="setting.footer" :responsive="responsive" :lang="setting.lang" :locale="locale" />
            <Colors :pointcolors="setting.pointcolors" :locale="locale" />
          </div>
        </div>
      </div>
      <div class="innerSide"><div class="sideBox">
        <div class="withSelect mb10">
          <span class="innerTitle setLabel">{{locale.edit_mode}}</span>
          <select v-model="responsive" class="input inlineInput" @change="setResponsive">
            <option value="mobile">{{locale.mobile}}</option>
            <option value="tablet">{{locale.tablet}}</option>
          </select>
        </div>
        <Preview
          :locale="locale"
          :site="setting.site"
          :colors="setting.colors"
          :imgs="setting.imgs"
          :skin="setting.skin"
          :style="setStyles"
          :responsive="responsive">
          <template v-slot:previewContent>
            <div class="sample">
              <p class="title">Sample receipt</p>
              <p class="small">Casher: SCE</p>
              <ul>
                <li>Date: {{$store.state.setting.date.list[$store.state.setting.date.default].format}}</li>
                <li>
                  <p><span>Butter Waffle</span><span>3.0</span></p>
                  <p><span>Agave Syrup</span><span>1.0</span></p>
                  <p><span>Green Salad</span><span>7.5</span></p>
                </li>
                <li class="total">
                  <p><span>Total</span><span><i v-html="$store.getters['setting/getCurrency']"></i> 11.5</span></p>
                </li>
              </ul>
              <p class="others">We will always give you fresh food.<br>Thank you.</p>
            </div>
          </template>
        </Preview>
      </div></div>
    </section>
    <div id="setContent">
      <div class="innerItem">
        <button type="button" class="btn btnFull btnPrimary" @click="save">{{locale.save}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'

import { mapGetters } from 'vuex'

import UTIL from '@/common/util'
import Site from '@/components/Setting/Site.vue'
import Footer from '@/components/Setting/Footer.vue'
import Skin from '@/components/Setting/Skin.vue'
import Colors from '@/components/Setting/Colors.vue'
import Header from '@/components/Setting/Header.vue'
import Lang from '@/components/Setting/Lang.vue'
import Currency from '@/components/Setting/Currency.vue'
import Date from '@/components/Setting/Date.vue'
import Font from '@/components/Setting/Font.vue'
import Order from '@/components/Setting/Order.vue'
import GuestType from '@/components/Setting/GuestType.vue'
import Mypage from '@/components/Setting/Mypage.vue'
import Inroom from '@/components/Setting/Inroom.vue'
import Preview from '@/components/Util/Preview.vue'

import DATE from '@/common/date'

export default {
  name: 'Setting',
  props: [
    'locale'
  ],
  components: {
    Site,
    Footer,
    Skin,
    Lang,
    Colors,
    Header,
    Currency,
    Date,
    Font,
    Preview,
    Order,
    GuestType,
    Mypage,
    Inroom
  },
  computed: {
    ...mapGetters({
      getSetting: 'setting/getData'
    }),
    setting () {
      return this.getSetting
    },
    setStyles () {
      return {
        fontFamily: this.setting.font.default
      }
    }
  },
  created () {
    this.removeDocumentClassAll()
  },
  mounted () {
  },
  beforeDestroy: function () {
    this.removeDocumentClassAll()
  },
  data () {
    return {
      responsive: 'mobile'
    }
  },
  methods: {
    setResponsive () {
      const data = {
        responsive: this.responsive,
        setting: this.setting
      }
      const toggle = this.responsive === 'tablet' ? 'add' : 'remove'
      document.body.classList[toggle]('editMode')
      document.body.classList[toggle]('tabletMode')
      console.log(this.responsive)
      this.$store.commit('setting/setResponsive', data)
    },
    removeDocumentClassAll () {
      const docsClass = document.body.classList
      docsClass.forEach(function (x) {
        document.body.classList.remove(x)
      })
    },
    save () {
      const setting = this.setting
      const title = this.$store.getters['util/filteredLanguageValues'](setting.site.title)
      const responsive = this.responsive === 'mobile' ? 'mobile' : 'tablet'
      const responsiveData = {
        mobile: {
          site: {
            logo: responsive === 'mobile' ? setting.site.logo : setting.responsive.mobile.site.logo
          },
          colors: responsive === 'mobile' ? setting.colors : setting.responsive.mobile.colors,
          imgs: responsive === 'mobile' ? setting.imgs : setting.responsive.mobile.imgs,
          footer: responsive === 'mobile' ? setting.footer : setting.responsive.mobile.footer
        },
        tablet: {
          site: {
            logo: responsive === 'tablet' ? setting.site.logo : setting.responsive.tablet.site.logo
          },
          colors: responsive === 'tablet' ? setting.colors : setting.responsive.tablet.colors,
          imgs: responsive === 'tablet' ? setting.imgs : setting.responsive.tablet.imgs,
          footer: responsive === 'tablet' ? setting.footer : setting.responsive.tablet.footer
        }
      }
      const settingData = {
        latest: moment().toISOString(),
        title: title,
        logo: setting.site.logo, // responsive
        colors: setting.colors, // responsive
        imgs: setting.imgs, // responsive
        pointcolors: setting.pointcolors,
        lang: {
          info: setting.lang.info,
          default: setting.lang.default,
          usable: setting.lang.usable,
          usableList: setting.lang.langOrder.map(code => setting.lang.info.find(l => l.c === code)),
          manual: setting.lang.manual,
          priorityAgent: setting.lang.priorityAgent,
          hiddenLangFlag: setting.lang.hiddenLangFlag,
          langOrder: setting.lang.langOrder
        },
        currency: setting.currency.info.find(x => x.c === setting.currency.default).c,
        currencyEntity: setting.currency.info.find(x => x.c === setting.currency.default).e,
        disabledCurrencySymbol: setting.currency.disabledCurrencySymbol,
        displayCurrencyType: setting.currency.displayCurrencyType,
        displayCurrencyUnit: setting.currency.displayCurrencyUnit,
        dateFormat: setting.date.dateFormat,
        dateformatDefault: setting.date.default,
        font: {
          added: setting.font.added,
          default: setting.font.default,
          ...setting.font.default2 && {
            default2: setting.font.default2
          },
          ...setting.font.default3 && {
            default3: setting.font.default3
          }
        },
        addedFont: setting.font.added,
        main: setting.main,
        skin: setting.skin, // responsive
        footer: setting.footer,
        order: setting.order,
        guestType: setting.guestType,
        mypage: setting.mypage,
        inroom: setting.inroom,
        responsive: responsiveData
      }
      this.$store.commit('onLoading', true)
      this.$store.dispatch('setting/setSetting', settingData)
        .then(res => {
          alert(this.locale.complete_save)
          this.$store.dispatch('setting/getSetting').then(res => {
            this.$store.dispatch('setting/setData', { data: res, responsive: responsive })
          })
          // this.$store.dispatch('setting/setSettingData', responsive)
          this.$store.commit('onLoading', false)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
[data-responsive="tablet"] {
  .innerSide {
    min-width: 620px;
  }
  .sample {
    min-height: 100%;
    padding: 60px 30px;
  }
}
.sample {
  padding: 60px 45px;
  border: 1px solid $color-lgrey2;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  .title {
    margin-bottom: 2px;
    padding-bottom: 0.2em;
    text-align: center;
    font-size: 1.6em;
    font-weight: bold;
    border-bottom: 4px solid $color-dark;
  }
  .small {
    padding-top: 0.2em;
    margin-bottom: 1.2em;
    font-size: 0.85em;
    color: $color-grey;
    border-top: 1px solid $color-dark;
  }
  ul {
    margin-bottom: 1em;
    border-top: 1px solid $color-lgrey;
    border-bottom: 1px solid $color-lgrey;
    li {
      padding: 0.8em 0;
      border-top: 1px dashed $color-lgrey;
      &:first-of-type {
        border-top: none;
      }
      p {
        display: flex;
        line-height: 1.8;
      }
      span + span {
        margin-left: auto;
      }
    }
    .total {
      font-size: 1.2em;
      font-weight: bold;
    }
  }
  .others {
    font-size: 12px;
    color: $color-lgrey;
  }
}
</style>
